import { Component } from "react";

import TitleBar from "../../components/ui/TitleBar";
import RectButton from "../../components/ui/button/RectButton";
import Select from "../../components/ui/Select";

import "./style.scss";
import Option from "../ui/Select/Option";
class CreditCardInfo extends Component {
    render() {
        return (
            <>
                <section className="cred-card-info">
                    <TitleBar title="Credit Card Information" />
                    <div className="box">
                        <div className="row">
                            <Select>
                                <Option value="1">My Visa 4723</Option>
                            </Select>
                            <RectButton className="add-bt" text="ADD NEW" onClick={this.props.onAddNew} />
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default CreditCardInfo;